import { sendCode } from '@/api/login'
import {send,check} from '@/api/code'
const state = {}
const mutations = {}
const actions = {
    sendCode({},params){
        return new Promise((resolve, reject) => {
            console.log(sendCode)
            sendCode(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    send({},params){
        return new Promise((resolve, reject) => {
            send(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    check({ }, params) {
        return new Promise((resolve, reject) => {
            check(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/code.js